import {rentalPointScheduleInterface} from "../types/types";

export class RentalPointName {
    public static readonly BRUSSEL: keyof rentalPointScheduleInterface = 25;
    public static readonly BEERSE: keyof rentalPointScheduleInterface = 18;
    public static readonly GHENT: keyof rentalPointScheduleInterface = 17;
    public static readonly HASSELT: keyof rentalPointScheduleInterface = 5;
    public static readonly HERENT: keyof rentalPointScheduleInterface = 1;
    public static readonly MERKSEM: keyof rentalPointScheduleInterface = 4;
    public static readonly BRUGGE: keyof rentalPointScheduleInterface = 36;
    public static readonly AALST: keyof rentalPointScheduleInterface = 38;
    public static readonly POELKAPELLE: keyof rentalPointScheduleInterface = 73;
}
